import script from "./CadastroTipoChamado.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroTipoChamado.vue?vue&type=script&setup=true&lang=js"

import "./CadastroTipoChamado.vue?vue&type=style&index=0&id=f3bdc534&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3bdc534"]])

export default __exports__